import CommonService from '../../../../services/commonService';
import React from 'react';
import { connect } from 'react-redux';

const saopauloIcon1 = '/assets/saopaulo/Home/BusesSaoPaulo-Website-Home-ServiceIcon1.svg';
const saopauloIcon2 = '/assets/saopaulo/Home/BusesSaoPaulo-Website-Home-ServiceIcon2.svg';
const saopauloIcon3 = '/assets/saopaulo/Home/BusesSaoPaulo-Website-Home-ServiceIcon3.svg';

const losnavegadoresIcon1 = '/assets/losnavegadores/home/service-one.svg';
const losnavegadoresIcon2 = '/assets/losnavegadores/home/service-two.svg';
const losnavegadoresIcon3 = '/assets/losnavegadores/home/service-three.svg';

const santajuanaIcon1 = '/assets/santajuana/Home/transporte-rural.svg';
const santajuanaIcon2 = '/assets/santajuana/Home/seguridad-bord.svg';
const santajuanaIcon3 = '/assets/santajuana/Home/flota-moderna.svg';

const chilebusIcon1 = '/assets/chilebus/Home/ChileBus-Website-Home-ServiceIcon-01.svg';
const chilebusIcon2 = '/assets/chilebus/Home/ChileBus-Website-Home-ServiceIcon-03.svg';
const chilebusIcon3 = '/assets/chilebus/Home/ChileBus-Website-Home-ServiceIcon-04.svg';

const pullmansurIcon1 = '/assets/pullmansur/Home/PullmandelSur-Website-Home-ServiceIcon1.png';
const pullmansurIcon2 = '/assets/pullmansur/Home/PullmandelSur-Website-Home-ServiceIcon2.png';
const pullmansurIcon3 = '/assets/pullmansur/Home/PullmandelSur-Website-Home-ServiceIcon3.png';
const pullmansurIcon4 = '/assets/pullmansur/Home/PullmandelSur-Website-Home-ServiceIcon4.png';

const getIconsAndTexts = operator => {
	const lightBg =
		operator && operator.color_codes && operator.color_codes.light_primary_color
			? operator.color_codes.light_primary_color
			: '#f7f7f7';
	const darkBg = operator && operator.operator_name === "losnavegadores" ? "#eaeaea" : operator && operator.color_codes && operator.color_codes.primary_color;

	const saopauloIconsAndTexts = [
		{ image: saopauloIcon1, caption: 'Servicios privados', background: lightBg },
		{ image: saopauloIcon2, caption: 'Turismo por la carretera Austral', background: darkBg },
		{ image: saopauloIcon3, caption: 'Servicios de turismo internacional', background: lightBg },
	];

	const santajuanaIconsAndTexts = [
		{ image: santajuanaIcon1, caption: 'Transporte rural de pasajeros', background: lightBg },
		{ image: santajuanaIcon2, caption: 'Seguridad a bordo', background: darkBg },
		{ image: santajuanaIcon3, caption: 'Moderna flota', background: lightBg },
	];

	const losnavegadoresIconsAndTexts = [
		{ image: losnavegadoresIcon1, caption: 'Viajes interurbanos', background: lightBg },
		{ image: losnavegadoresIcon2, caption: 'Servicios de turismo', background: darkBg },
		{ image: losnavegadoresIcon3, caption: 'Ticket digital', background: lightBg },
	];
	const chilebusIconsAndTexts = [
		{ image: chilebusIcon1, caption: 'Transporte interurbano', background: lightBg },
		{ image: chilebusIcon2, caption: 'Servicio de encomienda', background: darkBg },
		{ image: chilebusIcon3, caption: 'Transporte privado pasajeros', background: lightBg },
	];

	const pullmansurIconsAndTexts = [
		{ image: pullmansurIcon1, caption: 'Transporte interurbano', background: lightBg },
		{ image: pullmansurIcon2, caption: 'Seguridad a bordo', background: darkBg },
		{ image: pullmansurIcon3, caption: 'Servicio de encomienda', background: lightBg },
		{ image: pullmansurIcon4, caption: 'Transporte privado pasajeros', background: darkBg },
	];
	const name = operator && operator.operator_name;
	if (name === 'saopaulo') {
		return saopauloIconsAndTexts;
	}
	if (name === 'santajuana') {
		return santajuanaIconsAndTexts;
	}
	if (name === 'losnavegadores') {
		return losnavegadoresIconsAndTexts;
	}
	if (name === 'chilebus') {
		return chilebusIconsAndTexts;
	}
	if (name === 'pullmandelsur') {
		return pullmansurIconsAndTexts;
	} else {
		return [];
	}
};

const ThemeFourIconSection = props => {
	const operator = CommonService.getLocal('op') || props.home.operator;

	const renderIconsAndText = (item, key) => {
		return (
			<div
				className="icons-item"
				key={key}
				style={{
					background: item.background,
				}}
			>
				<div>
					<img src={item.image} alt="Giras de estudio" className="icon" />
				</div>
				<div
					className="caption"
					style={{
						color: operator && operator.color_codes && operator.color_codes.primary_text_color,
					}}
				>
					{item.caption}
				</div>
			</div>
		);
	};
	return (
		<div className="themes-theme-four-icon-section new-container">
			{getIconsAndTexts(operator).map((item, key) => {
				return renderIconsAndText(item, key);
			})}
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		themes: state.themes,
		home: state.home,
	};
}

export default connect(mapStateToProps, {})(ThemeFourIconSection);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeFour/common/ThemeFourIconSection.js